import events from 'events';
import Cookies from 'universal-cookie';

import { EVENTS_MAX_LISTENERS } from '../../utils/constants';
import {
  STATSIG_STABLE_ID_NEW_KEY,
  STATSIG_STABLE_ID_OLD_KEY,
} from './_app.constants';

export const hackMaxListeners = () => {
  // Mitigates the following:
  // `MaxListenersExceededWarning: Possible EventEmitter memory leak detected. 11 error listeners added to [TLSSocket]. Use emitter.setMaxListeners() to increase limit`

  // Only root cause I've found for this is that Next.js spawns a lot of fetch requests during ISR,
  // and reducing the amount of static generation reduces the chance of getting that warning.
  if (events.EventEmitter.defaultMaxListeners !== EVENTS_MAX_LISTENERS) {
    events.EventEmitter.defaultMaxListeners = EVENTS_MAX_LISTENERS;
  }
};

// TODO: Remove this year 2026!
export const getOldSdkStableIdIfNewNotPresent = (): string | undefined => {
  try {
    const oldValue = localStorage.getItem(STATSIG_STABLE_ID_OLD_KEY);
    const newValue = localStorage.getItem(STATSIG_STABLE_ID_NEW_KEY);
    if (oldValue && !newValue) {
      return localStorage.getItem(STATSIG_STABLE_ID_OLD_KEY) ?? undefined;
    }
  } catch (e) {
    // noop
  }
  return undefined;
};

export const getEventualStableIdFromMiddlewareCookie = ():
  | string
  | undefined => {
  try {
    const cookies = new Cookies();

    return cookies.get(STATSIG_STABLE_ID_NEW_KEY) ?? undefined;
  } catch (e) {
    // localStorage not available, not a problem
  }
  return undefined;
};
